import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  message,
} from "antd";
import React, { useState } from "react";
import { collection, doc, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase";

const MaintenanceInformation = ({ data, company, dataId }) => {
  const [isEditActive, setIsEditActive] = useState(false);
  const { TextArea } = Input;
  const dateFormat = "MM-DD-YYYY";

  const onFinish = (values) => {
    console.log("Success:", values);

    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, company);
      const propertyDocRef = doc(companyDocRef, "properties", dataId);
      updateDoc(propertyDocRef, {
        "maintenanceInformation.maintenanceLimit":
          values.maintenanceLimit || "",
        "maintenanceInformation.insuranceExpiration":
          values["insuranceExpiration"].format("DD-MM-YYYY") || "",
        "maintenanceInformation.isCoveredHomeWarranty":
          values.isCoveredHomeWarranty || "",
        "maintenanceInformation.unitPreEntryAuthorized":
          values.entryPreAuthorized || "",
        "maintenanceInformation.maintenanceInstructions":
          values?.onlineMaintenanceRequest || "",
        "maintenanceInformation.maintenanceNotes":
          values?.maintenanceNotes || "",
      });
      message.success("Maintenance Information Updated SuccessFully.", 3);
      setIsEditActive(false);
    } catch (error) {
      message.error("Error Updating Maintenance Information.", 3);

      console.error("not updated:", error);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const defaultValues = {
    maintenanceLimit: data?.maintenanceLimit,
    insuranceExpiration: data?.insuranceExpiration ? "" : "",
    isCoveredHomeWarranty: data?.isCoveredHomeWarranty,
    entryPreAuthorized: data?.unitPreEntryAuthorized,
    onlineMaintenanceRequest: data?.maintenanceInstructions,
    maintenanceNotes: data?.maintenanceNotes,
  };

  return (
    <>
      <Card
        title="Maintenance Information"
        extra={
          !isEditActive ? (
            <Button
              type="link"
              onClick={() => {
                setIsEditActive(true);
              }}
            >
              Edit
            </Button>
          ) : (
            ""
          )
        }
      >
        <Form
          name="basic"
          labelCol={{
            span: 11,
            offset: 4,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={defaultValues}
          autoComplete="off"
          colon={false}
        >
          <Form.Item label="Maintenance Limit" name="maintenanceLimit">
            {isEditActive ? (
              <Input type="Number" prefix="$" />
            ) : (
              <p>
                {data?.maintenanceLimit === "" ? "--" : data?.maintenanceLimit}
              </p>
            )}
          </Form.Item>

          <Form.Item label="Insurance Expiration" name="insuranceExpiration">
            {isEditActive ? (
              <DatePicker style={{ width: "100%" }} format={dateFormat} />
            ) : (
              <p>
                {data?.insuranceExpiration === ""
                  ? "--"
                  : data?.insuranceExpiration}
              </p>
            )}
          </Form.Item>
          <Form.Item
            label="Has Home Warranty Coverage"
            valuePropName="checked"
            name={"isCoveredHomeWarranty"}
          >
            {isEditActive ? (
              <Checkbox></Checkbox>
            ) : (
              <p>{data?.isCoveredHomeWarranty ? "Yes" : "No"}</p>
            )}
          </Form.Item>
          <Form.Item
            label="Unit Entry Pre-authorized"
            valuePropName="checked"
            name="entryPreAuthorized"
          >
            {isEditActive ? (
              <Checkbox></Checkbox>
            ) : (
              <p>{data?.insuranceExpiration ? "Yes" : "No"}</p>
            )}
          </Form.Item>
          <Form.Item label="Maintenance Notes" name="maintenanceNotes">
            {isEditActive ? (
              <TextArea
                style={{
                  height: 120,
                  resize: "none",
                }}
              />
            ) : (
              <p>
                {data?.maintenanceNotes === "" ? "--" : data?.maintenanceNotes}
              </p>
            )}
          </Form.Item>
          <Form.Item
            label="Online Maintenance Request Instructions"
            name={"onlineMaintenanceRequest"}
          >
            {isEditActive ? (
              <TextArea
                style={{
                  height: 120,
                  resize: "none",
                }}
                placeholder="e.g. In case of water leaks, do not file a maintenance request, call (888) 555-5555."
              />
            ) : (
              <p>
                {data?.maintenanceInstructions === ""
                  ? "--"
                  : data?.maintenanceInstructions}
              </p>
            )}
          </Form.Item>

          {isEditActive && (
            <Row gutter={16}>
              <Col>
                <Button type="primary" htmlType="submit">
                  Save
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    setIsEditActive(false);
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </Card>
    </>
  );
};

export default MaintenanceInformation;
